<template>
  <fieldset>
    <div class="form-wrap">
      <div>
        <label>Title</label>
        <v-select
          v-model="$parent.customer.title"
          :options="['Mr', 'Mrs', 'Miss', 'Ms', 'Lady', 'Sir', 'Dr']"
        ></v-select>
      </div>

      <div>
        <label for="first-name">First name</label>
        <input
          type="text"
          id="first-name"
          v-model="$parent.customer.first_name"
        />
      </div>

      <div>
        <label for="last-name">Last name</label>
        <input
          type="text"
          id="last-name"
          v-model="$parent.customer.last_name"
        />
      </div>
      
      <!-- <div>
        <label for="email">Email</label>
        <input id="email" type="email" v-model="$parent.customer.email" />
      </div>
      
      <div>
        <label for="mobile">Mobile number</label>
          <input
            type="text"
            id="mobile"
            v-model="$parent.customer.mobile_number"
          />
      </div> -->
      <div>
        <label for="phone">Phone number</label>
        <input type="text" id="phone" v-model="$parent.customer.phone_number" />
      </div>

      <div>
        <label for="street-address">Street address</label>
        <input
          type="text"
          id="street-address"
          v-model="$parent.customer.street_address"
        />
      </div>

      <div>
        <label for="address-line-2">Address line 2</label>
        <input
          type="text"
          id="address-line-2"
          v-model="$parent.customer.address_line_2"
        />
      </div>

      <div>
        <label for="address-line-2">Address line 3</label>
        <input
          type="text"
          id="address-line-2"
          v-model="$parent.customer.address_line_3"
        />
      </div>
      <div>
        <label for="address-line-2">Address line 4</label>
        <input
          type="text"
          id="address-line-2"
          v-model="$parent.customer.address_line_4"
        />
      </div>

      <div>
        <label for="town">Town/City</label>
        <input type="text" id="city" v-model="$parent.customer.town" />
      </div>

      <div>
        <label for="town">County</label>
        <input type="text" id="county" v-model="$parent.customer.county" />
      </div>

      <div>
        <label for="postcode">Postcode</label>
        <div class="form--inline mt-1">
          <input v-model="$parent.customer.postcode" type="text">
          <button class="button button--small" type="button" @click="postcodeLookup($parent.customer.postcode)"><span>Search</span></button>
        </div>
      </div>

      <div>
        <label for="country">Country</label>
        <v-select
          id="country"
          v-model="$parent.customer.country_id"
          label="name"
          index="id"
          :options="countries"
        ></v-select>
      </div>

      <div>
        <label for="affiliates">Affiliates</label>
        <v-select
          id="affiliates"
          v-model="$parent.customer.affiliate_id"
          label="name"
          index="id"
          :options="affiliates"
        ></v-select>
      </div>

      <div>
        <label for="is-special-opt_out_from_emails">Opt Out From E-mails</label>
        <label class="switch">
          <input id="opt_out_from_emails" type="checkbox" v-model="$parent.customer.opt_out_email">
          <span class="switch__slider"></span>
        </label>
      </div>
      <div>
        <label for="is-special-opt_out_from_emails">Opt Out From Mailing</label>
        <label class="switch">
          <input id="opt_out_from_emails" type="checkbox" v-model="$parent.customer.opt_out_mailing">
          <span class="switch__slider"></span>
        </label>
      </div>
      <div>
        <label for="is_blacklisted">Is Blacklisted</label>
        <label class="switch">
          <input id="is_blacklisted" type="checkbox" v-model="$parent.customer.is_blacklisted">
          <span class="switch__slider"></span>
        </label>
      </div>
      <!-- Special Accommodation Add Modal -->
      <div class="modal" v-if="showSuggestionsList">
      <h1>Select from suggestions</h1>
        <div class="box">
          <table class="table" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th>Address</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody v-if="suggestions.length > 0">
              <tr v-for="(suggestion, index) in suggestions" :key="index">
                <td>{{ suggestion.address }}</td>
                <td><a href="javascript:void(0);" @click="fetchFullAddress(suggestion.id)">Use Address</a></td>
              </tr>
            </tbody>
            <tbody v-else class="text-center">
             <tr class="odd"><td valign="top" colspan="2" class="dataTables_empty">No matching records found</td></tr>
            </tbody>
          </table>
        </div>
        <button type="button" class="icon icon--unlink" v-on:click="showSuggestionsList = false">Close</button>
      </div>

    </div>
    <hr/>
    <div class="row mb-3 p-3">
      <div class="col-md-12">
        <div class="row">
          <template v-for="(mobile_number, index) in customerMobileNumbers">
            <div class="col-md-3" :key="mobile_number.id">
              <div>
                <label for="mobile">
                  {{ (index == 0) ? 'Mobile number' : 'Secondary Mobile Number' }}
                  <span 
                    class="icon icon--delete" 
                    style="float: right;" @click="deleteField('mobile',index)"
                    v-if="index > 0"
                  ></span>
                </label>
                <div class="custom-phone-input">
                  <div class="country-code-picker" @click="toggleCountryDropdown(index, $event)">
                    <span v-if="mobile_number.selectedCountry">{{ mobile_number.selectedCountry.phone_code }}</span>
                    <span v-else>+44</span>
                    <span class="dropdown-arrow">▼</span>
                  </div>
                  <input
                    type="text"
                    id="mobile"
                    placeholder="Enter mobile number"
                    v-model="mobile_number.number"
                    @input="onlyNumbers($event, index)"
                  />
                  <div class="country-dropdown" v-if="mobile_number.showCountryDropdown">
                    <div class="search-box">
                      <input 
                        type="text" 
                        placeholder="Search..." 
                        :id="'country-search-' + index"
                        v-model="mobile_number.countrySearch" 
                        @input="filterCountries(index)"
                      />
                    </div>
                    <div class="country-list">
                      <div
                        v-for="(country, index_inside) in mobile_number.filteredCountries"
                        :key="index_inside"
                        class="country-option"
                        @click="selectCountry(index,country)"
                      >
                        <span>{{ country.name }}</span>
                        <span>{{ country.phone_code }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="col-md-1">
            <button class="button button--small mt-4" type="button" @click="addNewField('mobile')">
              <span>+</span>
            </button>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-3" v-for="(email_addresses, index) in customerEmailAddresses" :key="email_addresses.id">
            <div>
              <label for="email">
                Email
                <span 
                  class="icon icon--delete" 
                  style="float: right;" @click="deleteField('email',index)"
                  v-if="index > 0"
                ></span>
              </label>
              <input id="email" type="email" v-model="email_addresses.email" placeholder="Enter email address"/>
            </div>
          </div>
          <div class="col-md-1">
            <button 
              class="button button--small mt-4" 
              type="button" @click="addNewField('email')"><span>+</span></button>
          </div>
        </div>
      </div>
    </div>
    <hr/>
  </fieldset>
</template>

<script>
export default {
  name: "CustomerFields",
  data() {
    return {
      countries: [],
      affiliates: [],
      suggestions: [],
      showSuggestionsList: false,
      phoneNumber: '',
      countrySearch: '',
      filteredCountries: [],
      existingNumberCheck: {},
      selectedCountry: null,
      showCountryDropdown: false,
      customerEmailAddresses: [
        {
          id: Math.random().toString(36).substr(2, 9),
          email: null
        }
      ],
      customerMobileNumbers:[
        {
          id:Math.random().toString(36).substr(2, 9),
          countryCode: '+44',
          number: '',
          countrySearch:null,
          selectedCountry:null,
          showCountryDropdown: false,
          filteredCountries:[]
        }
      ]
    }
  },
  watch: {
    customerEmailAddresses: {
      handler(newVal) {
        // Ensure meta_data exists before setting email_addresses
        if (!this.$parent.customer.meta_data) {
          this.$parent.customer.meta_data = {};
        }
        this.$parent.customer.meta_data['email_addresses'] = newVal
        if (newVal.length > 0 && newVal[0].email) {
          this.$parent.customer.email = newVal[0].email;
        } 
      },
      deep: true
    },
    customerMobileNumbers: {
      handler(newVal) {
        // Ensure meta_data exists before setting mobile_numbers
        if (!this.$parent.customer.meta_data) {
          this.$parent.customer.meta_data = {};
        }
        this.$parent.customer.meta_data['mobile_numbers'] = newVal
        if (newVal.length > 0 && newVal[0].number) {
          this.$parent.customer.mobile_number = newVal[0].number;
        }
      },
      deep: true
    }
  },
  created() {
    this.getAffiliates();
    this.getCountries();
    this.handleCustomerMetaData();
  },
  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside);
    // Check if in the url we have postcode=BN16%201EH query present
    const urlParams = new URLSearchParams(window.location.search);
    const postcodeParam = urlParams.get('postcode')
    console.log(postcodeParam);
    if (postcodeParam) {
      this.postcodeLookup(decodeURIComponent(postcodeParam));
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getCountries() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "countries", {
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          this.countries = response.data;
          // Set the default country (UK)
          // this.selectedCountry = this.countries.find(c => c.code === 'GB');
          this.customerMobileNumbers.forEach(mobile_number => {
            mobile_number.filteredCountries = [...this.countries];
          });
          // this.filteredCountries = [...this.countries];
          
          // Parse existing number if available
          // this.parseExistingNumber();
          this.$store.dispatch("setLoadStatus");
        });
    },
    getAffiliates() {
      this.$store.dispatch("setLoadStatus");
      fetch(this.$api + "affiliates?type=active", {
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
      .then(res => res.json())
      .then(response => {
        this.affiliates = response.data;
        this.$store.dispatch("setLoadStatus");
      });
    },
    postcodeLookup(searchQuery) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'customers/postcode/lookup?postcode='+searchQuery , {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.suggestions = response.data ? response.data.suggestions : []
        if (this.suggestions.length > 0 ) {
          this.showSuggestionsList = true
          this.$store.dispatch('setLoadStatus')
        }else {
          this.$swal({
            icon: "info",
            title: "No list found",
          })
          this.$store.dispatch('setLoadStatus')
        }
      })
    },
    fetchFullAddress(id) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'customers/postcode/full-address?address_id='+id , {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.data) {
          this.$parent.customer.county = response.data.county
          this.$parent.customer.town = response.data.town_or_city
          this.$parent.customer.postcode = response.data.postcode
          this.$parent.customer.street_address = response.data.line_1
          this.$parent.customer.address_line_2 = response.data.line_2
          this.$parent.customer.address_line_3 = response.data.line_3
          this.$parent.customer.address_line_4 = response.data.line_4

          if (!response.data.line_3 && !response.data.line_4) {
            this.$parent.customer.address_line_3 = response.data.locality
          }else if (!response.data.line_4) {
            this.$parent.customer.address_line_4 = response.data.locality
          }
          this.showSuggestionsList = false;
          const result = this.countries.find((item) => item.name == response.data.country);
          if(result) {
            this.$parent.customer.country_id = result.id
          }
        }
        this.$store.dispatch('setLoadStatus')
      })
    },
    toggleCountryDropdown(index, event) {
      event.stopPropagation();
      this.customerMobileNumbers[index].showCountryDropdown = !this.customerMobileNumbers[index].showCountryDropdown;
    },
    selectCountry(index, country) {
      this.customerMobileNumbers[index].selectedCountry = country;
      this.customerMobileNumbers[index].showCountryDropdown = false;
      // this.updateFullNumber();
    },
    filterCountries(index) {
      if (!this.customerMobileNumbers[index].countrySearch) {
        this.customerMobileNumbers[index].filteredCountries = [...this.countries];
        return;
      }

      const search = this.customerMobileNumbers[index].countrySearch.toLowerCase();
      console.log(search);
      
      this.customerMobileNumbers[index].filteredCountries = this.countries.filter(country => {
        return country.name.toLowerCase().includes(search) || 
               country.phone_code.includes(search);
      });
    },
    handleClickOutside(event) {
      const dropdown = document.querySelector('.country-dropdown');
      const picker = document.querySelector('.country-code-picker');
      
      if (dropdown && picker && !dropdown.contains(event.target) && !picker.contains(event.target)) {
        this.showCountryDropdown = false;
      }
    },
    handleCustomerMetaData() {
      if (this.$parent.customer && this.$parent.customer.meta_data) {
        if (this.$parent.customer.meta_data['email_addresses'] && Array.isArray(this.$parent.customer.meta_data['email_addresses']) && this.$parent.customer.meta_data['email_addresses'].length > 0) {
          this.customerEmailAddresses = this.$parent.customer.meta_data['email_addresses'];
        }
        if (this.$parent.customer.meta_data['mobile_numbers'] && Array.isArray(this.$parent.customer.meta_data['mobile_numbers']) && this.$parent.customer.meta_data['mobile_numbers'].length > 0) {
          this.customerMobileNumbers = this.$parent.customer.meta_data['mobile_numbers'];
          // Ensure each mobile number has the necessary properties
          this.customerMobileNumbers.forEach(mobile_number => {
            if (!mobile_number.id) {
              mobile_number.id = Math.random().toString(36).substr(2, 9);
            }
            if (!mobile_number.countrySearch) {
              mobile_number.countrySearch = null;
            }
            if (!mobile_number.selectedCountry) {
              mobile_number.selectedCountry = null;
            }
            if (typeof mobile_number.showCountryDropdown === 'undefined') {
              mobile_number.showCountryDropdown = false;
            }
            if (!mobile_number.filteredCountries) {
              mobile_number.filteredCountries = [...this.countries];
            }
          });
        }
      }
    },
    addNewField(type) {
      if (type === 'mobile') {
        this.customerMobileNumbers.push({
          id:Math.random().toString(36).substr(2, 9),
          countryCode: '+44',
          number: '',
          selectedCountry:null,
          showCountryDropdown: false,
          countrySearch:null,
          filteredCountries:[...this.countries]
        });
      }
      if (type === 'email') {
        this.customerEmailAddresses.push({
          id: Math.random().toString(36).substr(2, 9),
          email: null
        });
      }
    },
    deleteField(type, index) {
      if (type === 'mobile' && this.customerMobileNumbers.length > 1) {
        this.customerMobileNumbers.splice(index, 1);
      }
      if (type === 'email' && this.customerEmailAddresses.length > 1) {
        this.customerEmailAddresses.splice(index, 1);
      }
    },
    onlyNumbers(event, index) {
      // Remove any non-numeric characters
      let value = event.target.value.replace(/[^0-9]/g, '');
      
      // Update the model with the cleaned value
      this.customerMobileNumbers[index].number = value;
      
      // Update the input field value
      event.target.value = value;
    }
  }
};
</script>

<style scoped>
/* Custom styles for phone input */
.custom-phone-input {
  display: flex;
  border: 1px solid #ccc;
  border-radius: 3px;
  position: relative;
  width: 100%;
}

.country-code-picker {
  display: flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  background-color: #f9f9f9;
  border-right: 1px solid #ccc;
  border-radius: 3px 0 0 3px;
  min-width: 50px;
}

.dropdown-arrow {
  margin-left: 5px;
  font-size: 10px;
}

.custom-phone-input input {
  flex: 1;
  border: none;
  padding: 7px 8px;
  width: 100%;
  border-radius: 0 3px 3px 0;
}

.country-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-height: 300px;
  width: 300px;
  overflow-y: auto;
  border-radius: 3px;
}

.search-box {
  padding: 10px;
  position: sticky;
  top: 0;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.search-box input {
  width: 100%;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 3px;
}

.country-list {
  padding: 0;
}

.country-option {
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}

.country-option:hover {
  background-color: #f5f5f5;
}
</style>